import { Button } from '@mui/material';
import React from 'react';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';
import Iconify from 'src/components/iconify';

function DownloadForPallet({ palletData }) {
  const exportToExcel = () => {
    // Transform data
    const orderRows =
      palletData?.orders?.map((order) => ({
        Tracking: order.tracking_number || '',
        Weight: order.weight || '',
        Website: order.declaration?.[0]?.website || '',
        Comment:
          order.orderHistory?.find(
            (h) =>
              h.body?.status === 'RECEIVED IN CHINA WAREHOUSE' && (h.comment || h.body?.comment)
          )?.comment ||
          order.orderHistory?.find(
            (h) => h.body?.status === 'RECEIVED IN CHINA WAREHOUSE' && h.body?.comment
          )?.body?.comment ||
          '',
        Amount: order?.declaration?.reduce((acc, curr) => acc + parseFloat(curr.price), 0),

        Currency: '¥',
      })) || [];
    // Generate worksheet
    const ws = XLSX.utils.json_to_sheet(orderRows, {
      header: ['Tracking', 'Weight', 'Website', 'Comment'],
    });

    // Generate workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Pallet Orders');

    // Save file
    XLSX.writeFile(wb, 'pallet_orders.xlsx');
  };

  return (
    <Button
      onClick={exportToExcel}
      variant="contained"
      disabled={!palletData?.orders?.length}
      startIcon={<Iconify icon="material-symbols:download" />}
      style={{ fontSize: '0.7rem' }}
    >
      DOWNLOAD
    </Button>
  );
}

DownloadForPallet.propTypes = {
  palletData: PropTypes.object,
};

export default DownloadForPallet;
